import type { SiteTab } from './sitePageTypes';

export default function SiteTabsNav({
  items,
  tab,
  onTabChange,
}: {
  items: { id: SiteTab; label: string }[];
  tab: SiteTab;
  onTabChange: (tab: SiteTab) => void;
}) {
  return (
    <div className="flex overflow-x-auto [&::-webkit-scrollbar]:hidden border-b border-ui-border">
      {items.map((item) => (
        <button
          key={item.id}
          type="button"
          onClick={() => onTabChange(item.id)}
          className={`shrink-0 whitespace-nowrap px-4 py-2 text-sm border-b-2 transition-colors ${
            tab === item.id ? 'border-ui-accent text-ui-text' : 'border-transparent text-ui-text-muted hover:text-ui-text'
          }`}
        >
          {item.label}
        </button>
      ))}
    </div>
  );
}
